import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class TokenStorage {
	/**
	 * Get User infor
	 * @returns {Observable<string>}
	 */
	public getUserInfo(): Observable<any> {
		var temp = localStorage.getItem('UserInfo');
		const user: any = JSON.parse(temp);
		return of(user);
	}
	/**
	 * Set user info
	 * @returns {UserInfo}
	 */
	public setUserInfo(info: any): TokenStorage {
		this.clearUserInfo();
		localStorage.setItem('UserInfo', info);
		return this;
	}

	/**
	 * Get access token
	 * @returns {Observable<string>}
	 */
	public getAccessToken(): Observable<string> {
		try{
			let user = JSON.parse(localStorage.getItem("UserInfo"));
			const token: string = <string>user.accessToken;
			return of(token);
		}
		catch(e) {
			return of("");
		}

	}

	/**
	 * Get refresh token
	 * @returns {Observable<string>}
	 */
	public getRefreshToken(): Observable<string> {
		const token: string = <string>localStorage.getItem('refreshToken');
		return of(token);
	}

	/**
	 * Get user roles in JSON string
	 * @returns {Observable<any>}
	 */
	public getUserRoles(): Observable<any> {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		const roles: any = user.roles;
		try {
			return of(roles);
		} catch (e) { }
	}

	/**
	 * Set access token
	 * @returns {TokenStorage}
	 */
	public setAccessToken(token: string): TokenStorage {
		localStorage.setItem('accessToken', token);

		return this;
	}

	/**
 * Set access token
 * @returns {Username}
 */
	public setUserName(username: string): TokenStorage {
		localStorage.setItem('username', username);

		return this;
	}

	public getUserName(): Observable<string> {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		const username: string = <string>user.username;
		return of(username);
	}

	public setFullName(fullname: string): TokenStorage {
		localStorage.setItem('fullname', fullname);

		return this;
	}

	public getFullName(): Observable<string> {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		const fullname: string = <string>user.fullname;
		return of(fullname);
	}

	/**
* Set access token
* @returns {Id_KH}
*/
	public setIdKH(idkh: string): TokenStorage {
		localStorage.setItem('Id_KH', idkh);

		return this;
	}

	/**
* Set access token
* @returns {Id_CV}
*/
	public setIdCV(idcv: string): TokenStorage {
		localStorage.setItem('Id_CV', idcv);

		return this;
	}

	/**
* Set access token
* @returns {Id_PB}
*/
	public setIdPB(idpb: string): TokenStorage {
		localStorage.setItem('Id_PB', idpb);

		return this;
	}


	public setIDUser(iduser: string): TokenStorage {
		localStorage.setItem('id', iduser);
		return this;
	}

	public getIDUser(): Observable<string> {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		const id: string = <string>user.id;
		return of(id);
	}

	/**
	 * Set refresh token
	 * @returns {TokenStorage}
	 */
	public setRefreshToken(token: string): TokenStorage {
		localStorage.setItem('refreshToken', token);

		return this;
	}

	/**
	 * Set user roles
	 * @param roles
	 * @returns {TokenStorage}
	 */
	public setUserRoles(roles: any): any {
		if (roles != null) {
			localStorage.setItem('userRoles', JSON.stringify(roles));
		}

		return this;
	}

	/**
	 * Set user roles
	 * @param roles
	 * @returns {TokenStorage}
	 */
	public setApiToken(token: any): any {
		if (token != null) {
			localStorage.setItem('apiToken', token);
		}

		return this;
	}

	public getApiToken(): Observable<string> {
		const token: string = <string>localStorage.getItem('apiToken');
		return of(token);
	}

	public setCoCauId(token: any): any {
		if (token != null) {
			localStorage.setItem('cocauid', token);
		}

		return this;
	}

	public getCoCauId(): Observable<string> {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		const cocau: string = <string>user.cocauid;
		return of(cocau);
	}

	public getDashboardWidgets(): Observable<any> {
		var temp = localStorage.getItem('dashboardWidgets');
		const dashboardConfig: any = JSON.parse(temp);
		try {
			return of(dashboardConfig);
		} catch (e) { }
	}

	public setDashboardWidgets(config: any): any {
		this.clearDashboardConfig();
		localStorage.setItem('dashboardWidgets', config);
		return this;
	}

	/**
	 * Remove storage
	 */
	public clearAll() {
		localStorage.clear();
	}
	public clearUserInfo(){
		localStorage.removeItem('UserInfo');
	}
	public clearDashboardConfig(){
		localStorage.removeItem('dashboardConfig');
	}
}
